import { CartNotFoundError } from "@/data";
import { Cart } from "@/data/interfaces/Cart";
import api from "@/services/api";
import { AxiosResponse } from "axios";

const _mapCartItems = (items: any) => items.map((item: any) => ({
    id: item.product.id,
    cart_item_id: item.id,
    name: item.product.name,
    price_cents: item.product.price_cents,
    total: item.discounted_line_total_cents ? item.discounted_line_total_cents?.toEuros() : item.line_total_cents?.toEuros(),
    preTotal: item.discounted_line_total_cents ? item.line_total_cents?.toEuros() : undefined,
    quantity: item.quantity,
    image_url: item.product.image_url
}));

const _mapCart = (response: AxiosResponse<any, any>) => ({
    id: response.data.cart.id,
    items: _mapCartItems(response.data.cart.items),
    discount: response.data.cart.discount_code,
    totals: {
        total: response.data.totals.discount_code_id ? response.data.totals.subtotal_cents?.toEuros() : response.data.totals.total_cents?.toEuros(),
        preTotal: response.data.cart.discount_code_id ? response.data.totals.subtotal_cents?.toEuros() : undefined,
        subtotalCents: response.data.totals.subtotal_cents,
        discountCents: response.data.totals.discount_cents,
        totalCents: response.data.totals.totalCents,
    }
})

const _cartNotFoundErrorWrap = async (action: any) => {
    try{
        const response = await action();
        return response;
    } catch (error: any) {
        if(error.status === 404)
            throw new CartNotFoundError(error.message);
        
        // if(error instanceof ResponseError)
        //     throw new CartNotFoundError(error.message);
        throw error;
    }
}

const addItem = async (cartId: string, id: number, quantity: number, image_url?: string) => _cartNotFoundErrorWrap(async() => {
    if (!cartId) throw new Error("addItem: No cart id provided");

    const response = await api.post(`/cart/${cartId}/items`, {
        product_id: id,
        quantity: quantity,
        image_url: image_url
    });

    return _mapCart(response);
})

const updateItem = async (cartId: string, id: number, quantity: number) => _cartNotFoundErrorWrap(async() => {
    if (!cartId) throw new Error("addItem: No cart id provided");

    const response = await api.post(`/cart/${cartId}/items`, {
        product_id: id,
        quantity: quantity
    });

    return _mapCart(response);
});

const removeItem = async (cartId: string, itemId: number) => _cartNotFoundErrorWrap(async() => {
    if (!cartId) throw new Error("No cart id provided");

    const response = await api.delete(`/cart/${cartId}/items/${itemId}`);
    return _mapCart(response);
})

const applyDiscountCode = async (cartId: string, code: string) => _cartNotFoundErrorWrap(async() => {
    if (!cartId) throw new Error("No cart id provided");

    const response = await api.post(`/cart/${cartId}/apply-discount`, { code });

    return {
        message: response.data.message,
        cart: _mapCart(response)
    } as { message: string, cart: Cart }
})

const fetchCartData = async (cartId: string) => _cartNotFoundErrorWrap(async() => {
    if (!cartId) throw new Error("No cart id provided");

    const response = await api.get(`/cart/${cartId}`);
    return _mapCart(response);
})

const createNewCart = async () => _cartNotFoundErrorWrap(async() => {
    const response = await api.post(`/cart`);
    return response.data.uuid;
})

export default {
    fetchCartData,
    createNewCart,
    applyDiscountCode,
    removeItem,
    addItem,
    updateItem
};